"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mapCategory = _interopRequireDefault(require("../mapCategory"));
var mapMenu = function mapMenu(menu, getUrl) {
  return menu.map(function (category) {
    if (category.is_active && category.include_in_menu) {
      return (0, _mapCategory["default"])(category, true, [], getUrl, true);
    }
  }).filter(function (category) {
    return category !== undefined;
  });
};
var _default = mapMenu;
exports["default"] = _default;